import React from 'react';
import {
    Box,
    Button,
    EmptyState,
    EmptyStateActions,
    EmptyStateDescription,
    EmptyStateIllustration,
    EmptyStateTitle,
    tokens,
} from '@vp/swan';
import { __ } from '@99designs/i18n';
import { StartNewProjectButton } from './StartNewProjectButton';

type DashboardEmptyStateProps =
    | {
          state: 'logged-out';
          onSignIn: () => void;
          onCreateAccount: () => void;
      }
    | {
          state: 'all' | 'current' | 'past' | 'draft';
          onSignIn?: never;
          onCreateAccount?: never;
      };

export const DashboardEmptyState = ({
    state,
    onSignIn,
    onCreateAccount,
}: DashboardEmptyStateProps) => {
    const titleMap = {
        all: __("You don't have any design services yet"),
        current: __("You don't have any current design services"),
        past: __("You don't have any past design services"),
        draft: __("You don't have any draft design services"),
        'logged-out': __('Sign in to access your design services'),
    };

    return (
        <Box
            marginY="between-subsections"
            style={{
                paddingTop: tokens.SwanSemSpaceBetweenSubsections,
                paddingBottom: tokens.SwanSemSpaceBetweenSubsections,
            }}
        >
            <EmptyState>
                <EmptyStateIllustration illustrationType="generic" />
                <EmptyStateTitle>{titleMap[state]}</EmptyStateTitle>
                <EmptyStateDescription>
                    {state === 'logged-out'
                        ? __("Don't have an account? Create one now.")
                        : state === 'draft'
                        ? __(
                              'Create a brief and save your progress to come back and finish it later.'
                          )
                        : __(
                              "Work with a designer to craft a custom design that's just right for you."
                          )}
                </EmptyStateDescription>
                <EmptyStateActions>
                    {state === 'logged-out' ? (
                        <>
                            <Button skin="primary" onClick={onSignIn}>
                                {__('Sign in')}
                            </Button>
                            <Button skin="secondary" onClick={onCreateAccount}>
                                {__('Create account')}
                            </Button>
                        </>
                    ) : (
                        <StartNewProjectButton />
                    )}
                </EmptyStateActions>
            </EmptyState>
        </Box>
    );
};
